import { NgModule } from "@angular/core";
import { DepositGigadetInteracPage } from "./deposit-interac";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "src/app/components/components.module";

@NgModule({
  declarations: [DepositGigadetInteracPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class DepositInteracPageModule {}
